<template>
	<div class="fondoModal">
		<div>
			<div>
				<div class="card">
					<div class="card-header bg-info text-white">
						<b>{{etiqueta.toUpperCase()}}:</b>	Selecciona un locutor
						<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="cerrar">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="card-body">
						<div class="row">
							<div class="col-8">
								<div class="input-group">
									<div class="input-group-prepend">
										<div class="input-group-text">
											Buscar
										</div>
									</div>
									<input autofocus type="text" class="form-control form-control-sm" placeholder="Escribe el nombre del locutor" v-model="filtro" @keyup="buscar()">
									<div class="input-group-append">
										<button class="btn btn-info" @click="nuevo()">
											<span class="fa fa-plus"></span>
											Nuevo
										</button>
									</div>
								</div>
								<table class="table table-hover table-condensed text-left">
									<thead>
										<tr>
											<th>Avatar</th>
											<th>Nombre</th>
											<th>Sexo</th>
											<th>Procedencia</th>
											<th></th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="loc in listado" :key="loc.ID_locutor">
											<td style="vertical-align:middle;">
												<img :src="loc.avatar" style="width:60px;height:60px;" alt="Avatar" class="rounded-circle">
											</td>
											<td style="vertical-align:middle;">{{loc.nombre}} {{loc.apellidos}}</td>
											<td style="vertical-align:middle;">{{loc.sexo}}</td>
											<td style="vertical-align:middle;">{{loc.procedenciaNombre}}</td>
											<td style="vertical-align:middle;">
												<button class="btn btn-sm btn-success" @click="selecciona(loc)">
													<span class="fa fa-check"></span>
												</button>
												<button class="btn btn-sm btn-warning" @click="editar(loc)">
													<span class="fa fa-edit"></span>
												</button>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
							<div class="col">
								<h5>
									<span v-if="etiqueta.match(/^loc[0-9]/)">Locutores</span>
									<span v-if="etiqueta.match(/^loca[0-9]/)">Locutoras</span>
									<span v-if="etiqueta.match(/^locx[0-9]/)">Locutores/as</span>
									habituales de este cliente
								</h5>
								<div class="text-center mt-3 text-danger" v-if="habituales.length === 0">
									<b>No hay histórico de este anunciante</b>
								</div>
								<table class="table table-hover table-condensed">
									<tbody>
										<tr v-for="locutor in habituales" :key="locutor.ID_locutor">
											<td style="vertical-align:middle;width:45px;">
												<img :src="locutor.avatar" class="rounded-circle" style="width:40px;">
											</td>
											<td style="vertical-align:middle;text-align:left;">
												{{locutor.nombre}} {{locutor.apellidos}}
												<br>
												<i>{{locutor.total}} cuñas grabadas</i>
											</td>
											<td style="width:30px;text-align:right;">
												<button class="btn btn-success btn-sm" @click="selecciona(locutor)">
													<span class="fa fa-check"></span>
												</button>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
				<editor-locutor :locutor="editando" v-if="editando" @cerrar="editando = null"></editor-locutor>
			</div>
		</div>
	</div>
</template>


<script>
import EditorLocutor from './editor-locutor'
import API from '../../services/api'

export default {
	name: 'selecciona-locutor',
	components: {
		'editor-locutor': EditorLocutor
	},
	props: ['etiqueta', 'tarea'],
	data: function () {
		return {
			filtro: '',
			listado: [],
			habituales: [],
			seleccionado: null,
			editando: null
		}
	},

	created () {
		const tipo = this.etiqueta.replace(/[^a-zA-Z]/g, '')
		// Buscamos los locutores habituales
		API.getLocutoresHabituales(tipo, this.tarea.produccion.anunciante_ID)
			.then(res => {
				this.habituales = res.data.listado
			})
			.catch(e => {
				this.$store.commit('alertas/nueva', {
					titulo: 'Error',
					mensaje: e.response.data.error
				})
			})
	},

	methods: {
		buscar () {
			if (this.filtro === '') {
				this.listado = []
				return
			}
			API.queryLocutores({cadena: this.filtro})
				.then(res => {
					this.listado = res.data.listado
				})
				.catch(e => {
					this.$store.commit('alertas/nueva', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		selecciona (locutor) {
			this.$emit('seleccion', locutor)
		},

		nuevo () {
			this.editando = {
				ID_locutor: null,
				nombre: '',
				apellidos: '',
				avatar: '/media/static/hombre.svg',
				email: '',
				telefono: '',
				procedencia_ID: null,
				sexo: 'hombre',
				estilos: [],
				activo: true
			}
		},

		editar (loc) {
			this.editando = loc
		},

		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/produccion/vue/components/produccion/seleccion-locutor.vue